import React from 'react';

export interface UserAvatarProps {
  name: string | null;
  imageUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-12 h-12 text-lg',
};

/**
 * UserAvatar component displays a user's avatar image or their initial.
 * Falls back to first letter of name/email if no image is provided.
 */
export const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  imageUrl,
  size = 'md',
  className = '',
}) => {
  // Get the first character for the avatar initial
  const initial = (name || 'U')[0].toUpperCase();

  const baseClasses = `
    rounded-full flex items-center justify-center font-semibold
    bg-primary-600 dark:bg-primary-500 text-white
    ${sizeClasses[size]}
    ${className}
  `
    .trim()
    .replace(/\s+/g, ' ');

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={name || 'User avatar'}
        className={`${baseClasses} object-cover`}
      />
    );
  }

  return (
    <div className={baseClasses} aria-label={`Avatar for ${name || 'User'}`}>
      {initial}
    </div>
  );
};

export default UserAvatar;
